import React, { FC, ReactNode } from "react";
import { BsChevronDown } from "react-icons/bs";
import cx from "classnames";

interface FAQAccordionItem {
    title: string;
    description: string | ReactNode;
}

interface FAQAccordionProps {
    title: string;
    items: FAQAccordionItem[];
    toggleBtn?: boolean;
}

const FAQAccordion: FC<FAQAccordionProps> = ({ items, title: groupTitle, toggleBtn }) => {
    const [showMore, setShowMore] = React.useState<boolean>(false);
    return (
        <div className="py-5">
            {toggleBtn &&
                items.map((item, index) => {
                    if (showMore === false && index < 5) {
                        return (
                            <div key={item.title} className={cx("tab w-full overflow-hidden mb-4", { "border-b border-solid": index < items.length - 1 })}>
                                <input className="absolute hidden" id={`tab-${item.title}`} type="checkbox" name={groupTitle} />
                                <label
                                    className="flex items-center w-full leading-normal text-lg md:text-xl tracking-wide cursor-pointer py-1 text-inherit"
                                    htmlFor={`tab-${item.title}`}
                                >
                                    <h3 className="flex-1 text-2xl m-0 lg:text-xl font-medium text-white">{item.title}</h3>
                                    <div className="expand-toggle-icon rounded-full flex items-center p-1">
                                        <BsChevronDown />
                                    </div>
                                </label>
                                <div className="tab-content overflow-hidden">
                                    <p className="pb-4 pr-5 text-base font-light leading-relaxed tracking-wide whitespace-pre-line" style={{ color: "#aab0c3" }}>
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        );
                    } else if (showMore) {
                        return (
                            <div key={item.title} className={cx("tab w-full overflow-hidden mb-4", { "border-b border-solid": index < items.length - 1 })}>
                                <input className="absolute hidden" id={`tab-${item.title}`} type="checkbox" name={groupTitle} />
                                <label
                                    className="flex items-center w-full leading-normal text-lg md:text-xl tracking-wide cursor-pointer py-1 text-inherit"
                                    htmlFor={`tab-${item.title}`}
                                >
                                    <h3 className="flex-1 text-2xl m-0 lg:text-xl font-medium text-white">{item.title}</h3>
                                    <div className="expand-toggle-icon rounded-full flex items-center p-1">
                                        <BsChevronDown />
                                    </div>
                                </label>
                                <div className="tab-content overflow-hidden">
                                    <p className="pb-4 pr-5 text-base font-light leading-relaxed tracking-wide whitespace-pre-line" style={{ color: "#aab0c3" }}>
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        );
                    }
                })}
            {toggleBtn && (
                <button className="bg-white px-5 py-2 font-medium text-base rounded-md mx-auto block" style={{ color: "#2D3748" }} onClick={() => setShowMore((pre) => !pre)}>
                    {showMore ? "Show less" : "More FAQ "}
                </button>
            )}
            {toggleBtn === undefined &&
                items.map((item, index) => {
                    if (showMore === false && index < 5) {
                        return (
                            <div key={item.title} className={cx("tab w-full overflow-hidden mb-4", { "border-b border-solid": index < items.length - 1 })}>
                                <input className="absolute hidden" id={`tab-${item.title}`} type="checkbox" name={groupTitle} />
                                <label
                                    className="flex items-center w-full leading-normal text-lg md:text-xl tracking-wide cursor-pointer py-1 text-inherit"
                                    htmlFor={`tab-${item.title}`}
                                >
                                    <h3 className="flex-1 text-2xl m-0 lg:text-xl font-medium text-white">{item.title}</h3>
                                    <div className="expand-toggle-icon rounded-full flex items-center p-1">
                                        <BsChevronDown />
                                    </div>
                                </label>
                                <div className="tab-content overflow-hidden">
                                    <p className="pb-4 pr-5 text-base font-light leading-relaxed tracking-wide whitespace-pre-line" style={{ color: "#aab0c3" }}>
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        );
                    }
                })}
            <style jsx>
                {`
                    .tab {
                        border-color: rgba(255, 255, 255, 0.23);
                    }

                    .tab-content {
                        padding-top: 1rem;
                        max-height: 0;

                        -webkit-transition: all 200ms ease-in;
                        -o-transition: all 200ms ease-in;
                        transition: all 200ms ease-in;
                    }

                    .tab input:checked ~ .tab-content {
                        max-height: initial;
                    }

                    @media (min-width: 768px) {
                        .tab input:checked ~ .tab-content {
                            max-height: initial;
                        }
                    }

                    .tab input + label {
                        transition: all 200ms ease-in;
                    }

                    .tab input + label > .expand-toggle-icon {
                        transition: all 200ms ease-in;
                    }

                    .tab input + label:hover > .expand-toggle-icon {
                        background-color: #ffffff10;
                    }

                    .tab input:checked + label > .expand-toggle-icon {
                        transform: rotate(-180deg);
                        background-color: #ffffff20;
                    }
                `}
            </style>
        </div>
    );
};

export default FAQAccordion;
